import { Typography } from "@mui/material"
import { useExhibitorCopyText } from "hooks/exhibitors/useExhibitorsCopyText"
import React from "react"
import { makeStyles } from "tss-react/mui-compat"

const useStyles = makeStyles()(
  (theme) => ({
    pageName: {
      ...theme.fonts.raleway500,
      fontSize: 36,
      lineHeight: "1.175",
    },
  })
)

export const ExhibitorsPageName = () => {
  const { classes } = useStyles()
  const exhibitorCopyText = useExhibitorCopyText()

  return (
    <Typography component="h1" variant="h1" className={classes.pageName}>
      {exhibitorCopyText?.plural}
    </Typography>
  )
}
